<template>
    <h2 class="heading" style="width:1110px;">Expense Request Details</h2>
    <div class="detail">
        <table style="width:100%">
            <tr><th>Request No</th> <td width="210">{{expense.id}}</td>
                <th>Title</th> <td colspan="3">{{expense.title}}</td>
            </tr>
            <tr><th>Requester</th> <td>{{expense.requester}}</td>
                <th>Created at</th> <td width="210">{{expense.created}}</td>
                <th>Created by</th> <td>{{expense.createdBy}}</td>
            </tr>
            <tr><th>Approver</th> <td>{{expense.approver}}</td>
                <th>Status</th> <td colspan="3">{{expense.status}}</td>
            </tr>
            <tr><th>Total Amount</th> <td>
                <span class="amount">{{global.number_format(expense.totalAmount, 2)}}</span>
                <span class="unit">HKD</span>
            </td><th>Attachments</th>
                <td colspan="3">
                    <el-tag v-for="(item, index) in attachments" :key="index" size="large" @close="removeFile(item)">
                    <a href="" @click.prevent="global.down(item.link, item.name)">{{item.name}}</a></el-tag>
                </td>
            </tr>
            <tr>
                <th style="vertical-align: top;"><br/><br/>Expense Items</th> 
                <td colspan="5">
                    <el-table :data="expenseDetails" :style="'width:99%;' + (expenseDetails.length>5 ? 'height:400px;' : '') + 'margin:15px auto;'" :row-class-name="tableRowClassName">
                         <el-table-column type="index" label="No" align="center" />
                        <el-table-column prop="date" label="Date" width="130" align="center" />
                        <el-table-column prop="category" label="Category" width="150"/>
                        <el-table-column prop="description" label="Description" width="310"/>
                        <el-table-column prop="paidTo" label="Paid to" width="150"/>
                        <el-table-column prop="amount" align="right" label="Amount">
                            <template #default="scope">{{global.number_format(scope.row.amount, 2)}}</template>
                        </el-table-column>
                        <el-table-column prop="ccy" label="CCY"/>
                        <el-table-column prop="fxRate" label="FX rate" align="right">
                            <template #default="scope">{{global.number_format(scope.row.fxRate, 2)}}</template>
                        </el-table-column>
                        <el-table-column prop="amountHKD" label="Amount HKD" align="right">
                            <template #default="scope"><span class="amount">{{global.number_format(scope.row.amountHKD, 2)}}</span></template>
                        </el-table-column>
                        <el-table-column prop="reimbursableAmtHKD" width="100" align="right" label="Reimburs (HKD)">
                            <template #default="scope"><span style="padding-right:10px;">{{global.number_format(scope.row.reimbursableAmtHKD, 2)}}</span></template>
                        </el-table-column>
                    </el-table>
                </td>
            </tr>
            <tr v-if="expense.canApprove">
                <th>Review Result</th>
                <td>
                    <el-radio-group v-model="status">
                        <el-radio label="approved" value="Approved" class="Approved"><b>Approved</b></el-radio>
                        <el-radio label="rejected" value="Rejected" class="Rejected"><b>Rejected</b></el-radio>
                    </el-radio-group>
                </td>
                <th>Comments</th>
                <td colspan="3">
                    <el-input v-if="expense.canApprove" type="textarea" v-model="comments"/>
                </td>
            </tr>
        </table>
        
        <div v-if="errMsg != ''" style="width:1024px;margin-top:15px;"><el-alert :title="errMsg" type="error" /></div>
        <div class="buttonDIV" style="width:1100px;">
            <el-button v-if="expense.canApprove" @click="approveExpense" style="margin-right:10px;" type="primary">Approve</el-button>
            <el-button v-if="expense.canEdit" @click="$router.push('/expense/editExpense?code='+expense.idMD5)" style="margin-right:10px;" type="primary">Edit</el-button>
            <el-button @click="backExpenseList">Back to expense list</el-button>
            <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                <img src="@/assets/loading.gif" style="height:24px;"/>
            </span>
        </div>
    </div>
</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            expense: {},
            expenseDetails: [],
            dept: '',
            today: '',
            status: null,
            remarks: '',
            comments: '',
            errMsg: '',
            code: null,
            global,
            loading: false,
        }
    },
    async mounted() {
        this.global.index = "expense";
        this.code = this.$route.query.code;
        let result = await AXIOS("/expense/getExpense", {code: this.code});
        if (result.success) {
            this.expense = result.data.expense;
            this.expenseDetails = result.data.expenseDetails;
        } else {
            this.errMsg = result.errMsg;
        }
    },
    computed: {
        attachments() {
            let files = new Array();
            if (this.expense.attachments && this.expense.attachments.length) {
                let filesArr = this.expense.attachments.split(";")
                for (var i = 0; i < filesArr.length; i++) {
                    files.push({
                        name: filesArr[i].split(":")[0], 
                        link: filesArr[i].split(":")[1]
                    });
                }
            }
            return files;
        },
    },
    methods: {
        backExpenseList() {
            let fromPath = sessionStorage.getItem("fromPath");
            if (fromPath && fromPath.startsWith("/expense/")) {
                this.$router.push(fromPath);
            } else {
               if (this.global.hasRight('expense', 'approver') || this.global.hasRight('expense', 'statistician')) {
                   this.$router.push('/expense/allExpenseList');
               } else {
                   this.$router.push('/expense/myExpenseList');
               }
            }
        },

        async approveExpense() {
            this.errMsg = '';
            if (this.status == null) {
                this.errMsg = "Please select 'Approve result'";
                return;
            } else if (this.status == 'Rejected') {
                if (this.comments == '') {
                    this.errMsg = "Please input 'Reasons of rejection''";
                    return;
                }
            }

            if (this.loading) return;
            this.loading = true;
            let data = { code: this.code, comments: this.comments, status: this.status};
            let result = await AXIOS("/expense/approveExpense", data);
            if (result.success) {
                this.backExpenseList();
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
    }
}
</script>

<style scoped>
    .detail th { width: 160px; }
    .signOff  { margin:10px 0px; }
    .Rejected { color:#E20 !important; }
    .Approved { color:#0A2; }
    .link {color: #369;}
    .contractDetails { color:#999; font-size:13px; }
    .contractDetails span {color:#333; text-decoration: underline;}
    .right {text-align: right;}
    .center {text-align: center;}
    .unit {margin-left:5px;}
    .amount {color:#26B; font-weight: bold;}
</style>